<template>
  <div class="filter_wrapper">
    <div class="label">{{ label }}</div>
    <div ref="filterList" class="filter_list" :class="isFold ? 'is_open' : ''">
      <span v-if="!disableAll" @click="clickItem({ id: '' })" class="filter_item" :class="currentId === '' ? 'active' : ''">全部</span>
      <span @click="clickItem(item)" class="filter_item" :class="currentId === item.id ? 'active' : ''" v-for="item in options" :key="item.id">{{ item.name }}</span>
    </div>
    <div v-if="hasMore" class="has_more" @click="isFold = !isFold">{{ isFold ? '收起' : '更多' }}</div>
  </div>
</template>

<script>
export default {
  name: 'SearchItem',
  props: {
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
    disableAll: {
      type: Boolean,
      default: false,
    },
    activeId: {
      type: String,
      default: '',
    },
    defaultValue: Number,
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFold: false,
      hasMore: false,
      currentId: '',
    }
  },
  created() {
    // 兼容不要【全部】筛选项逻辑
    this.currentId = this.activeId
    const area = sessionStorage.getItem('area')
    if(area) {
      this.isFold = this.defaultOpen
    }
  },
  mounted() {
    window.addEventListener('resize', this.calcMoreBtn)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcMoreBtn)
  },
  methods: {
    clickItem(option) {
      this.currentId = option.id
      this.$emit('click', option)
    },
    calcMoreBtn() {
      this.$nextTick(() => {
        let childWidthTotal = 0
        const maxWidth = this.$refs.filterList.scrollWidth
        const children = this.$refs.filterList.children
        Array.from(children).forEach((childEl) => {
          childWidthTotal += childEl.scrollWidth + 10 // 10是边距
        })
        if (childWidthTotal > maxWidth) {
          this.hasMore = true
        } else {
          this.hasMore = false
        }
      })
    },
  },
  watch: {
    options: {
      handler(newOptions) {
        if (newOptions.length) {
          this.calcMoreBtn()
        }
      },
    },
    defaultValue(id) {
      if(id && id !== ''){
        this.currentId = id
      }
    },
  },
}
</script>

<style lang="less" scoped>
.filter_wrapper {
  display: flex;
  margin-bottom: 16px;
  .label {
    margin-right: 10px;
  }
  .filter_list {
    flex: 1;
    display: flex;
    height: 24px;
    overflow: hidden;
    line-height: 24px;
    flex-wrap: wrap;
    &.is_open {
      height: auto;
    }
    .filter_item {
      flex-shrink: 0;
      height: 24px;
      line-height: 24px;
      color: #333;
      border-radius: 4px;
      padding: 0 10px;
      transition: all 0.4s ease;
      margin: 0 10px 10px 0;
      cursor: pointer;
      &.active {
        background: #0072f7;
        color: #fff;
      }
    }
  }

  .has_more {
    line-height: 24px;
    flex-basis: 60px;
    text-align: center;
    color: #999;
    cursor: pointer;
  }
}
</style>
